<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>Routenplaner</li>
    </ul>
  </div>
  <div class="flex flex-row gap-2">
    <ng-select
      class="flex-none w-60"
      [items]="weekNumbers"
      [multiple]="true"
      [(ngModel)]="selectedWeekNumbers"
      (ngModelChange)="loadStoreData()"
      placeholder="Kalenderwoche"
    />
    <!-- <div class="bm-input pr-0">
      <label>Kalenderwoche:</label>
      <ng-multiselect-dropdown
        class="w-40 border-0"
        [placeholder]="'Auswählen'"
        [data]="weekNumbers"
        [(ngModel)]="selectedWeekNumbers"
        [settings]="weekNumberSelectionSettings"
        (onSelect)="loadStoreData()"
        (onSelect)="loadStoreData()"
      />
    </div> -->
    <ng-select
      class="flex-none w-96"
      [items]="technicians"
      [bindValue]="'id'"
      [bindLabel]="'name'"
      [multiple]="true"
      [(ngModel)]="selectedTechnicians"
      (ngModelChange)="onSelectTechnician()"
      placeholder="Techniker"
    />
    <!-- <div class="bm-input pr-0">
      <label>Techniker:</label>
      <ng-multiselect-dropdown
        class="w-80 border-0"
        [placeholder]="'Auswählen'"
        [data]="technicians"
        [(ngModel)]="selectedTechnicians"
        [settings]="technicianSelectionSettings"
        (onSelect)="onSelectTechnician()"
        (onDeSelect)="onSelectTechnician()"
      />
    </div> -->
  </div>
</div>
<div class="page-content px-4 pb-2 grid grid-cols-2 gap-2">
  <mgl-map
    class="border border-base-300 rounded-md overflow-clip"
    [style]="'mapbox://styles/mapbox/streets-v9'"
    [zoom]="plannedSelected[0] ? [12] : [6]"
    [center]="plannedSelected[0] ? [plannedSelected[0].store_lng, plannedSelected[0].store_lat] : [9.993682, 53.551086]"
  >
    @for (row of filteredPlannedAssignments.concat(filteredUnplannedAssignments); track $index) {
      @if (row.store_lat && row.store_lng) {
        <mgl-marker [lngLat]="[row.store_lng, row.store_lat]">
          <div
            (click)="handleMarkerClick(row)"
            class="marker"
            [style.borderColor]="
              plannedSelected[0] &&
              plannedSelected[0].store_lat === row.store_lat &&
              plannedSelected[0].store_lng === row.store_lng
                ? 'black'
                : 'white'
            "
            [style.backgroundColor]="row.status_color"
            title="{{ row.store_name }}"
          ></div>
        </mgl-marker>
      }
    }
  </mgl-map>

  <div class="bm-card bm-card-sm bm-card-border border-base-300 bg-base-100 rounded-md">
    <div class="bm-card-body flex flex-col">
      <div class="bm-card-title bg-base-100">Geplante Einsätze</div>
      <ngx-datatable
        class="flex-fill"
        [rows]="filteredPlannedAssignments"
        [columns]="columns"
        columnMode="force"
        [scrollbarV]="true"
        [headerHeight]="20"
        [footerHeight]="0"
        [rowHeight]="35"
        [selected]="plannedSelected"
        [selectionType]="selectionType"
        (activate)="onActivate($event)"
        (select)="onSelect($event)"
      />
    </div>
  </div>

  <div class="bm-card bm-card-sm bm-card-border border-base-300 bg-base-100 rounded-md col-span-2">
    <div class="bm-card-body flex flex-col">
      <div class="bm-card-title flex flex-row w-full">
        <span> Ungeplante Einsätze </span>
        <span class="flex-fill"></span>
        <div class="bm-join">
          <button class="bm-btn bm-btn-error" (click)="destroyAll()">Alle Löschen</button>
          <a class="bm-btn bm-btn-info" [href]="env.apiURL + 'operations/assignment_planning_unplanned.xlsx'">
            Export (excel)
          </a>
        </div>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="ml-2">
          <input type="file" class="bm-file-input" name="importfile" (change)="onFileChange($event)" />
          <button class="bm-btn bm-btn-ghost" type="submit">Import</button>
        </form>
      </div>
      <ngx-datatable
        class="flex-fill"
        [rows]="filteredUnplannedAssignments"
        [columns]="columnsTechnicians"
        columnMode="force"
        [scrollbarV]="true"
        [headerHeight]="20"
        [footerHeight]="0"
        [rowHeight]="35"
      />
    </div>
  </div>
</div>

<ng-template #statusTemplate let-row="row" let-value="value" let-i="index">
  <strong> **{{ row.status }}** </strong>
</ng-template>

<ng-template #statusTpl let-row="row" let-value="value" let-column="column">
  <div class="flex items-center justify-center h-full w-full">
    <div class="bm-badge" [style.backgroundColor]="row.status_color" title="{{ value }}">{{ value.split(" ")[0] }}</div>
  </div>
</ng-template>

<ng-template #dateTpl let-row="row" let-value="value" let-column="column">
  <div class="">
    {{ formatDate(value) }}
  </div>
</ng-template>

<ng-template #weekTpl let-row="row" let-value="value" let-column="column">
  <div class="">
    {{ calendarWeek(value) }}
  </div>
</ng-template>
